const merchantAccredit = {
    path: 'merchantAccredit',
    component: resolve => require(['@/pages/admin/aftersales/merchantAccredit/index.vue'], resolve),
    meta: {
        requireAuth: true
    },
    children: [

    ]
}

export default merchantAccredit